import type { FC } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { GridErrorBoundaryFallback } from 'components/common';
import GoToTestForm from './GoToTestForm';

const AddGoToTest: FC = () => {
  return (
    <ErrorBoundary FallbackComponent={GridErrorBoundaryFallback}>
      <GoToTestForm />
    </ErrorBoundary>
  );
};

export default AddGoToTest;